import { render } from "./BackgroundGradiant.vue?vue&type=template&id=3d7e5ebd&scoped=true&ts=true"
import script from "./BackgroundGradiant.vue?vue&type=script&lang=ts"
export * from "./BackgroundGradiant.vue?vue&type=script&lang=ts"

import "./BackgroundGradiant.vue?vue&type=style&index=0&id=3d7e5ebd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7e5ebd"]])

export default __exports__